/** Imports */
import {
    GET_FIOS_INTERNET_DATA_URL,
    GET_BASIC_INTERNET_DATA_URL,
    GET_FIOS_TV_URL
} from './APIurls';

import { equipments } from "../Pages/CustomizeOrder/PhoneServiceComponent/PhoneEquipment/Products";

/** Major Services Constant */
export const MAJOR_SERVICES = {
    PHONE: 'PHONE',
    DATA: 'DATA',
    VIDEO: 'VIDEO',
    HSI: 'HSI'
}

/** Flow Constant */
export const FLOW = {
    STANDALONE: 'STANDALONE',
    DOUBLE: 'DOUBLE_BUNDLE',
    TRIPLE: 'TRIPLE_BUNDLE',
    DOUBLE_FLEX: 'DOUBLE_FLEX',
    BANNER: 'BANNER_FLOW',
    NON_BANNER: 'NON_BANNER_FLOW',
    BUNDLE_OFFER: 'BUNDLE_OFFER_FLOW'
}

export const REVERSE_BUNDLE = {
    REVERSE_FLEX: 'VIDEO+DATA',
    REVERSE_BDV_DATA: 'BDV+DATA',
    REVERSE_PHONE_DATA: 'PHONE+DATA',
    REVERSE_BDV_DATA_VIDEO: 'BDV+DATA+VIDEO',
    REVERSE_PHONE_DATA_VIDEO: 'PHONE+DATA+VIDEO',
    REVERSE_VIDEO_DATA_BDV: 'VIDEO_DATA_BDV',
    REVERSE_VIDEO_DATA_PHONE: 'VIDEO_DATA_PHONE',
    REVERSE_BDV_VIDEO_DATA: 'BDV_VIDEO_DATA',
    REVERSE_PHONE_VIDEO_DATA: 'PHONE_VIDEO_DATA',
    REVERSE_HSI: 'PHONE+HSI_INTERNET',
    REVERSE_VIDEO_BDV: 'VIDEO+BDV',
    REVERSE_VIDEO_PHONE: 'VIDEO+PHONE',
    REVERSE_VIDEO_BDV_DATA: 'VIDEO+BDV+DATA',
    REVERSE_VIDEO_PHONE_DATA: 'VIDEO+PHONE+DATA',

}

/** Bundle Constant */
export const BUNDLE = {
    BDV: 'BDV',
    PHONE: 'STANDARD_PHONE',
    DATA: 'DATA',
    VIDEO: 'VIDEO',
    HSI: 'HSI_INTERNET',
    BDV_DATA: 'BDV+DATA',
    DATA_BDV: 'DATA+BDV',
    BDV_VIDEO: 'BDV+VIDEO',
    BDV_DATA_VIDEO: 'BDV+DATA+VIDEO',
    PHONE_DATA: 'PHONE+DATA',
    HSI_PHONE: 'HSI_INTERNET+PHONE',
    PHONE_HSI: 'PHONE+HSI_INTERNET',
    DATA_PHONE: 'DATA+PHONE',
    PHONE_VIDEO: 'PHONE+VIDEO',
    PHONE_DATA_VIDEO: 'PHONE+DATA+VIDEO',
    FLEX: 'DATA+VIDEO',
    REVERSE_FLEX: 'VIDEO+DATA'
}

export const HSI_BUNDLES = [
    BUNDLE.HSI, BUNDLE.HSI_PHONE, BUNDLE.PHONE_HSI
]

export const SP_BUNDLES = [
    BUNDLE.PHONE, BUNDLE.PHONE_DATA, BUNDLE.HSI_PHONE, BUNDLE.PHONE_HSI, BUNDLE.DATA_PHONE, BUNDLE.PHONE_VIDEO, BUNDLE.PHONE_DATA_VIDEO
]

/** Update For Constant */
export const UPDATEFOR = {
    STANDALONE_BDV: 'STANDALONE_BDV',
    STANDALONE_PHONE: 'STANDALONE_STANDARD_PHONE',
    STANDALONE_DATA: 'STANDALONE_FIOS_DATA',
    STANDALONE_VIDEO: 'STANDALONE_FIOS_VIDEO',
    STANDALONE_HSI: 'STANDALONE_HSI_DATA',
    DOUBLE_BDV: 'DOUBLE_BDV',
    DOUBLE_PHONE: 'DOUBLE_STANDARD_PHONE',
    DOUBLE_DATA: 'DOUBLE_FIOS_DATA',
    DOUBLE_VIDEO: 'DOUBLE_FIOS_VIDEO',
    DOUBLE_HSI: 'DOUBLE_HSI_DATA',
    DOUBLE_FLEX_FIOS_DATA: 'DOUBLE_FLEX_FIOS_DATA',
    DOUBLE_FLEX_FIOS_VIDEO: 'DOUBLE_FLEX_FIOS_VIDEO',
    TRIPLE_BDV: 'TRIPLE_BDV',
    TRIPLE_PHONE: 'TRIPLE_PHONE',
    TRIPLE_DATA: 'TRIPLE_FIOS_DATA',
    TRIPLE_VIDEO: 'TRIPLE_FIOS_VIDEO',
}

/** Get Fios Data/HSI Url */
export const getSelectedDataBundleURL = (bundleServiceType) => {
    let url = '';
    if (bundleServiceType === "DSL") {
        url = GET_BASIC_INTERNET_DATA_URL;
    } else {
        url = GET_FIOS_INTERNET_DATA_URL;
    }
    return url;
};

/** Get Fios Flex bundle Url */
export const getSelectedVideoBundleURL = () => {
    let url = '';
    url = GET_FIOS_TV_URL;
    return url;
};


/** Get Flow Type */
export const getFlowToUpdate = (servicesInCart) => {
    if (servicesInCart === '' || servicesInCart === BUNDLE.BDV || servicesInCart === BUNDLE.PHONE || servicesInCart === BUNDLE.DATA ||
        servicesInCart === BUNDLE.HSI || servicesInCart === BUNDLE.VIDEO) {
        return FLOW.STANDALONE;
    } else if (servicesInCart !== '' && (servicesInCart === BUNDLE.BDV_DATA || servicesInCart === BUNDLE.BDV_VIDEO ||
        servicesInCart === BUNDLE.PHONE_DATA ||
        servicesInCart === BUNDLE.DATA_BDV || servicesInCart === BUNDLE.DATA_PHONE || servicesInCart === BUNDLE.PHONE_VIDEO ||
        servicesInCart === BUNDLE.FLEX || servicesInCart === BUNDLE.PHONE_HSI || servicesInCart === BUNDLE.HSI_PHONE ||
        servicesInCart === BUNDLE.VIDEO)) {
        return FLOW.DOUBLE;
    } else if (servicesInCart !== '' && (servicesInCart === BUNDLE.BDV_DATA_VIDEO || servicesInCart === BUNDLE.PHONE_DATA_VIDEO)) {
        return FLOW.TRIPLE;
    }
}


/*********************************************************Form Request Payloads ********************************************************/





// Form Request Payload with Non Do response For Double Bundle...
export const formFiosDataBDVBundleInfoRequestPayload = (doubleBundlePlan) => {
    let request = {};
    if (doubleBundlePlan) {
        // BDV+DATA
        request = {
            bundleID: doubleBundlePlan.BID,
            dpackgeId: doubleBundlePlan.SpeedPKGID,
            dHcid: doubleBundlePlan.SpeedHCID,
            contract: doubleBundlePlan.Contract,
            bdvID: doubleBundlePlan.BDVStationID,
            ptype: doubleBundlePlan.FlowType,
            bRc: doubleBundlePlan.BundleRC,
            Nlines: 1,
            upselSelected: false,
            TVPackageId: 0,
            TVHCID: 0
        };
    }
    return request;
}

export const formFiosDataPhoneBundleInfoRequestPayload = (doubleBundlePlan) => {
    let request = {};
    if (doubleBundlePlan) {
        request = {
            bundleID: doubleBundlePlan.BID,
            tvID: 0,
            nLines: 1,
            contract: doubleBundlePlan.Contract,
            hcid: 0,
            ptype: doubleBundlePlan.BundleType,
            bRc: doubleBundlePlan.BundleRC,
            upselSelected: false,
        };
    }
    return request;
}

export const formHSIPhoneBundleInfoRequestPayload = (doubleBundlePlan, topSpeed) => {
    let request = {};
    if (doubleBundlePlan) {
        request = {
            bundleID: doubleBundlePlan.BID,
            tvID: 0,
            nLines: 1,
            contract: doubleBundlePlan.Contract,
            hcid: topSpeed?.Services[0].ID || 0,
            ptype: doubleBundlePlan.BundleType,
            bRc: doubleBundlePlan.BundleRC,
            upselSelected: false,
        };
    }
    return request;
}


export const formFiosDataVideoBundleInfoRequestPayload = (doubleBundlePlan) => {
    let request = {};
    if (doubleBundlePlan) {
        request = {
            BID: doubleBundlePlan.BID,
            dHCID: doubleBundlePlan.SpeedHCID,
            dPAKGID: doubleBundlePlan.SpeedPKGID,
            TVPackageID: doubleBundlePlan.TVPackagId,
            TVHCID: doubleBundlePlan.TVHCId,
            RC: doubleBundlePlan.BundleRC,
            contract: doubleBundlePlan.Contract,
        };
    }
    return request;
}

// Form Request Payload with Non Do response For Triple Bundle...
export const formFiosDataBDVTVBundleInfoRequestPayload = (tripleBundlePlan) => {
    let request = {};
    if (tripleBundlePlan) {
        // BDV+DATA+VIDEO
        request = {
            bundleID: tripleBundlePlan.BID,
            dpackgeId: tripleBundlePlan.SpeedPKGID,
            dHcid: tripleBundlePlan.SpeedHCID,
            contract: tripleBundlePlan.Contract,
            bdvID: tripleBundlePlan.BDVStationID,
            ptype: tripleBundlePlan.FlowType,
            bRc: tripleBundlePlan.BundleRC,
            Nlines: 1,
            upselSelected: false,
            TVPackageId: tripleBundlePlan.TVPackagId,
            TVHCID: tripleBundlePlan.TVHCId
        };
    }
    return request;
}

export const formFiosDataStandardPhoneTVBundleInfoRequestPayload = (tripleBundlePlan) => {
    let request = {};
    if (tripleBundlePlan) {
        // PHONE+DATA+VIDEO
        request = {
            bundleID: tripleBundlePlan.BID,
            tvID: tripleBundlePlan.Services && tripleBundlePlan.Services?.length > 0 ? tripleBundlePlan.Services[1].ID : 0,
            nLines: 1,
            contract: tripleBundlePlan.Contract,
            hcid: 0,
            ptype: tripleBundlePlan.BundleType,
            bRc: tripleBundlePlan.BundleRC,
            upselSelected: false,
        };
    }
    return request;
}

// for reverse...
export const formFiosDataBDVTVBundleInfoRequestPayloadForReverseBundle = (tripleBundlePlan, selectedDataId, selectedTvId, selectedPhoneServiceId, reverseFlow) => {
    let request = {};
    if (tripleBundlePlan) {
        if (reverseFlow === REVERSE_BUNDLE.REVERSE_VIDEO_DATA_BDV) {
            request = {
                // have to check for data and tv package id with backend team...
                bundleID: tripleBundlePlan.BID,
                dpackgeId: tripleBundlePlan.SpeedPKGID,
                dHcid: selectedDataId,
                contract: tripleBundlePlan.Contract,
                bdvID: tripleBundlePlan.BDVStationID,
                ptype: tripleBundlePlan.FlowType,
                bRc: tripleBundlePlan.BundleRC,
                Nlines: 1,
                upselSelected: false,
                TVPackageId: tripleBundlePlan.TVPackagId,
                TVHCID: selectedTvId
            };
        } else if (reverseFlow === REVERSE_BUNDLE.REVERSE_BDV_DATA_VIDEO) {
            request = {
                // have to check for data and tv package id with backend team...
                bundleID: tripleBundlePlan.BID,
                dpackgeId: tripleBundlePlan.SpeedPKGID,
                dHcid: selectedDataId,
                contract: tripleBundlePlan.Contract,
                bdvID: selectedPhoneServiceId,
                ptype: tripleBundlePlan.FlowType,
                bRc: tripleBundlePlan.BundleRC,
                Nlines: 1,
                upselSelected: false,
                TVPackageId: tripleBundlePlan.TVPackagId,
                TVHCID: tripleBundlePlan.TVHCId
            };
        }

    }
    return request;
}

export const formFiosDataStandardPhoneTVBundleInfoRequestPayloadForReverseBundle = (tripleBundlePlan, selectedDataId, selectedTvId, selectedPhoneServiceId, reverseFlow) => {
    let request = {};
    if (tripleBundlePlan) {
        // PHONE+DATA+VIDEO
        if (reverseFlow === REVERSE_BUNDLE.REVERSE_VIDEO_DATA_PHONE) {
            request = {
                bundleID: tripleBundlePlan.BID,
                tvID: selectedTvId,
                nLines: 1,
                contract: tripleBundlePlan.Contract,
                hcid: selectedDataId,
                ptype: tripleBundlePlan.BundleType,
                bRc: tripleBundlePlan.BundleRC,
                upselSelected: false,
            };
        } else if (reverseFlow === REVERSE_BUNDLE.REVERSE_PHONE_DATA_VIDEO) {
            request = {
                bundleID: tripleBundlePlan.BID,
                tvID: tripleBundlePlan.Services[0].ID,
                nLines: 1,
                contract: tripleBundlePlan.Contract,
                hcid: selectedDataId,
                ptype: tripleBundlePlan.BundleType,
                bRc: tripleBundlePlan.BundleRC,
                upselSelected: false,
            };
        }
    }
    return request;
}

/**  Standlone Request Payloads */
export const formGenericDataRequestBodyBasedOnFlow = (selectedDataPlan, requestFrom, requestParams, flowType, servicesInCart) => {
    const { params } = requestParams;
    let requestBody = {};
    let updateDataBodyFromPhone = {};
    // issue fix...
    if (requestFrom && requestFrom !== '' && (requestFrom === BUNDLE.BDV || requestFrom === REVERSE_BUNDLE.REVERSE_BDV_DATA) && selectedDataPlan) {
        servicesInCart = BUNDLE.DATA_BDV;
        updateDataBodyFromPhone = {
            "DataSelection": {
                // "OldID": selectedDataPlan ? selectedDataPlan.BID : "",
                "NewID": selectedDataPlan ? selectedDataPlan.BID : ""
            },
            "DataPlanSelection": {
                // "OldID": selectedDataPlan.SpeedHCID ? selectedDataPlan.SpeedHCID.toString() : "",
                "NewID": selectedDataPlan.SpeedHCID ? selectedDataPlan.SpeedHCID.toString() : "",
            },
        }

    } else if (requestFrom && requestFrom !== '' && (requestFrom === BUNDLE.PHONE || requestFrom === REVERSE_BUNDLE.REVERSE_PHONE_DATA) && selectedDataPlan) {
        servicesInCart = BUNDLE.DATA_PHONE;
        updateDataBodyFromPhone = {
            "DataSelection": {
                //  "OldID": selectedDataPlan ? selectedDataPlan.BID : "",
                "NewID": selectedDataPlan ? selectedDataPlan.BID : ""
            },
            // changes for updatefiosdata sending empty dataplanselection for data+phone
            "DataPlanSelection": {
                // "OldID": selectedDataPlan.Services[0].ID ? selectedDataPlan.Services[0].ID.toString() : "",
                "NewID": selectedDataPlan.Services[0].ID ? selectedDataPlan.Services[0].ID.toString() : "",
            },
        }
    } else if (requestFrom && requestFrom !== '' && requestFrom === BUNDLE.VIDEO && selectedDataPlan) {
        servicesInCart = BUNDLE.FLEX;
        flowType = FLOW.DOUBLE;
        updateDataBodyFromPhone = {
            "DataSelection": {
                // "OldID": selectedDataPlan ? selectedDataPlan.BID.toString() : "",
                "NewID": selectedDataPlan ? selectedDataPlan.BID.toString() : ""
            },
            "DataPlanSelection": {
                //  "OldID": selectedDataPlan.SpeedHCID ? selectedDataPlan.SpeedHCID.toString() : "",
                "NewID": selectedDataPlan.SpeedHCID ? selectedDataPlan.SpeedHCID.toString() : "",
            },
        }
    }
    if (flowType === FLOW.STANDALONE) {
        requestBody = {
            "DataSelection": {
                //  "OldID": params[0].selectedDetails.Services && params[0].selectedDetails.Services[0].ID ? params[0].selectedDetails.Services[0].ID.toString() : "",
                "NewID": params[0].selectedDetails.Services && params[0].selectedDetails.Services[0].ID ? params[0].selectedDetails.Services[0].ID.toString() : ""
            },
            "DataPlanSelection": {
                // "OldID": params[1].selectedDetails ? params[1].selectedDetails.PrdID : ""
            },
            "RouterSelection": {
                "OldID": params[2].oldEquipment ? params[2].oldEquipment.PrdID : "",
                "NewID": params[2].selectedDetails ? params[2].selectedDetails.PrdID : ""
            },
            "SelectedVASPlans": (params[4].selectedDetails?.length != 0) ? params[4].selectedDetails : [
                {
                    "PkgID": "",
                    "PPPID": "0"
                }
            ],

            /* SelectedPPS is the Tech Support Pro and service protection plan*/
            "SelectedPPS": params.premiumSupportDetails,
            "addedbuttonSelection":
            {
                "addedbutton": "INR:inrlblrequired=Added,addlblrequired=Added,prmlblrequired=Added,eqmlblrequired=Added,accordionsubheaderdivinr=\n                                                                             \n                                                                        Internet Speed\n                                                                    ,accordionsubheaderdivprm=     Tech Support Pro,accordionsubheaderdivequ=     I do not need a router, I will provide my own ,accordionsubheaderdivadd=     I do not need a Security Bundle"
            }
        };

    } else if (flowType === FLOW.DOUBLE) {
        if (servicesInCart === BUNDLE.DATA_BDV) {
            requestBody = {
                "DataSelection": {
                    // "OldID": params[0].selectedDetails ? params[0].selectedDetails.BID : "",
                    "NewID": params[0].selectedDetails ? params[0].selectedDetails.BID : ""
                },
                "DataPlanSelection": {
                    // "OldID": params[0].selectedDetails.SpeedHCID ? params[0].selectedDetails.SpeedHCID.toString() : "",
                    "NewID": params[0].selectedDetails.SpeedHCID ? params[0].selectedDetails.SpeedHCID.toString() : "",
                },
                "RouterSelection": {
                    "OldID": params[2].oldEquipment ? params[2].oldEquipment.PrdID : "",
                    "NewID": params[2].selectedDetails ? params[2].selectedDetails.PrdID : ""
                },
                "SelectedVASPlans": (params[4].selectedDetails?.length != 0) ? params[4].selectedDetails : [
                    {
                        "PkgID": "",
                        "PPPID": "0"
                    }
                ],

                /* SelectedPPS is the Tech Support Pro and service protection plan*/
                "SelectedPPS": params.premiumSupportDetails,
                "addedbuttonSelection":
                {
                    "addedbutton": "INR:inrlblrequired=Added,addlblrequired=Added,prmlblrequired=Added,eqmlblrequired=Added,accordionsubheaderdivinr=\n                                                                             \n                                                                        Internet Speed\n                                                                    ,accordionsubheaderdivprm=     Tech Support Pro,accordionsubheaderdivequ=     I do not need a router, I will provide my own ,accordionsubheaderdivadd=     I do not need a Security Bundle"
                }
            };
        } else if (servicesInCart === BUNDLE.DATA_PHONE) {
            requestBody = {
                "DataSelection": {
                    // "OldID": params[0].selectedDetails ? params[0].selectedDetails.BID : "",
                    "NewID": params[0].selectedDetails ? params[0].selectedDetails.BID : ""
                },
                "DataPlanSelection": {
                    //  "OldID": params[0].selectedDetails.Services[0].ID ? params[0].selectedDetails.Services[0].ID.toString() : "",
                    "NewID": params[0].selectedDetails.Services[0].ID ? params[0].selectedDetails.Services[0].ID.toString() : "",
                },
                "RouterSelection": {
                    "OldID": params[2].oldEquipment ? params[2].oldEquipment.PrdID : "",
                    "NewID": params[2].selectedDetails ? params[2].selectedDetails.PrdID : ""
                },
                "SelectedVASPlans": (params[4].selectedDetails?.length != 0) ? params[4].selectedDetails : [
                    {
                        "PkgID": "",
                        "PPPID": "0"
                    }
                ],

                /* SelectedPPS is the Tech Support Pro and service protection plan*/
                "SelectedPPS": params.premiumSupportDetails,
                "addedbuttonSelection":
                {
                    "addedbutton": "INR:inrlblrequired=Added,addlblrequired=Added,prmlblrequired=Added,eqmlblrequired=Added,accordionsubheaderdivinr=\n                                                                             \n                                                                        Internet Speed\n                                                                    ,accordionsubheaderdivprm=     Tech Support Pro,accordionsubheaderdivequ=     I do not need a router, I will provide my own ,accordionsubheaderdivadd=     I do not need a Security Bundle"
                }
            };
        } else if (servicesInCart === BUNDLE.HSI_PHONE) {
            requestBody = {
                "DataSelection": {
                    // "OldID": params[0].selectedDetails ? params[0].selectedDetails.BID : "",
                    "NewID": params[0].selectedDetails ? params[0].selectedDetails.BID : ""
                },
                "DataPlanSelection": {
                    //  "OldID": params[0].selectedDetails.Services[0].ID ? params[0].selectedDetails.Services[0].ID.toString() : "",
                    "NewID": params[0].selectedDetails.Services[0].ID ? params[0].selectedDetails.Services[0].ID.toString() : "",
                },
                "RouterSelection": {
                    "OldID": params[2].oldEquipment ? params[2].oldEquipment.PrdID : "",
                    "NewID": params[2].selectedDetails ? params[2].selectedDetails.PrdID : ""
                },
                "SelectedVASPlans": (params[4].selectedDetails?.length != 0) ? params[4].selectedDetails : [
                    {
                        "PkgID": "",
                        "PPPID": "0"
                    }
                ],

                /* SelectedPPS is the Tech Support Pro and service protection plan*/
                "SelectedPPS": params.premiumSupportDetails,
                "addedbuttonSelection":
                {
                    "addedbutton": "HSIINR:lblrequiredhsiinr=Added,lblrequiredhsiprem=Added,lblrequiredhsiequ=Added,lblrequiredhsiinstall=Added,lblrequiredhsiadd=Added,accordionsubheaderdivhsiinr=     Basic Internet Solutions Dynamic 7.1M/768K 2 Year,accordionsubheaderdivhsiprem=                  Business Preferred         ,accordionsubheaderdivhsiequ=                  Wireless Modem/Router          ,accordionsubheaderdivhsiinstall=                  Onsite Installation          accordionsubheaderdivhsiadd=     Verizon Cloud 500 GB"
                }
            };
        }
        else if (servicesInCart === BUNDLE.FLEX) {
            requestBody = {
                "DataSelection": {
                    //  "OldID": params[0].selectedDetails ? params[0].selectedDetails.BID.toString() : "",
                    "NewID": params[0].selectedDetails ? params[0].selectedDetails.BID.toString() : ""
                },
                "DataPlanSelection": {
                    //   "OldID": params[0].selectedDetails.SpeedHCID ? params[0].selectedDetails.SpeedHCID.toString() :
                    //       params[0].selectedDetails.Services ? params[0].selectedDetails.Services[0].ID.toString() : '',
                    "NewID": params[0].selectedDetails.SpeedHCID ? params[0].selectedDetails.SpeedHCID.toString() :
                        params[0].selectedDetails.Services ? params[0].selectedDetails.Services[0].ID.toString() : ''
                },
                "RouterSelection": {
                    "OldID": params[2].oldEquipment ? params[2].oldEquipment.PrdID : "",
                    "NewID": params[2].selectedDetails ? params[2].selectedDetails.PrdID : ""
                },
                "SelectedVASPlans": (params[4].selectedDetails?.length != 0) ? params[4].selectedDetails : [
                    {
                        "PkgID": "",
                        "PPPID": "0"
                    }
                ],

                /* SelectedPPS is the Tech Support Pro and service protection plan*/
                "SelectedPPS": params.premiumSupportDetails,
                "addedbuttonSelection":
                {
                    "addedbutton": "INR:inrlblrequired=Added,addlblrequired=Added,prmlblrequired=Added,eqmlblrequired=Added,accordionsubheaderdivinr=\n                                                                             \n                                                                        Internet Speed\n                                                                    ,accordionsubheaderdivprm=     Tech Support Pro,accordionsubheaderdivequ=     I do not need a router, I will provide my own ,accordionsubheaderdivadd=     I do not need a Security Bundle"
                }
            };
        }


    } else if (flowType === FLOW.TRIPLE) {

        if (servicesInCart === BUNDLE.BDV_DATA_VIDEO) {
            requestBody = {
                "DataSelection": {
                    //  "OldID": params[0].selectedDetails ? params[0].selectedDetails.BID : "",
                    "NewID": params[0].selectedDetails ? params[0].selectedDetails.BID : ""
                },
                "DataPlanSelection": {
                    //  "OldID": params[0].selectedDetails.SpeedHCID ? params[0].selectedDetails.SpeedHCID.toString() : "",
                    "NewID": params[0].selectedDetails.SpeedHCID ? params[0].selectedDetails.SpeedHCID.toString() : "",
                },
                "RouterSelection": {
                    "OldID": params[2].oldEquipment ? params[2].oldEquipment.PrdID : "",
                    "NewID": params[2].selectedDetails ? params[2].selectedDetails.PrdID : ""
                },
                "SelectedVASPlans": (params[4].selectedDetails?.length != 0) ? params[4].selectedDetails : [
                    {
                        "PkgID": "",
                        "PPPID": "0"
                    }
                ],

                /* SelectedPPS is the Tech Support Pro and service protection plan*/
                "SelectedPPS": params.premiumSupportDetails,
                "addedbuttonSelection":
                {
                    "addedbutton": "INR:inrlblrequired=Added,addlblrequired=Added,prmlblrequired=Added,eqmlblrequired=Added,accordionsubheaderdivinr=\n                                                                             \n                                                                        Internet Speed\n                                                                    ,accordionsubheaderdivprm=     Tech Support Pro,accordionsubheaderdivequ=     I do not need a router, I will provide my own ,accordionsubheaderdivadd=     I do not need a Security Bundle"
                }
            };
        } else if (servicesInCart === BUNDLE.PHONE_DATA_VIDEO) {
            requestBody = {
                "DataSelection": {
                    //  "OldID": params[0].selectedDetails ? params[0].selectedDetails.BID : "",
                    "NewID": params[0].selectedDetails ? params[0].selectedDetails.BID : ""
                },
                "DataPlanSelection": {
                    //  "OldID": params[0].selectedDetails.Services[0].ID ? params[0].selectedDetails.Services[0].ID.toString() : "",
                    "NewID": params[0].selectedDetails.Services[0].ID ? params[0].selectedDetails.Services[0].ID.toString() : "",
                },
                "RouterSelection": {
                    "OldID": params[2].oldEquipment ? params[2].oldEquipment.PrdID : "",
                    "NewID": params[2].selectedDetails ? params[2].selectedDetails.PrdID : ""
                },
                "SelectedVASPlans": (params[4].selectedDetails?.length != 0) ? params[4].selectedDetails : [
                    {
                        "PkgID": "",
                        "PPPID": "0"
                    }
                ],

                /* SelectedPPS is the Tech Support Pro and service protection plan*/
                "SelectedPPS": params.premiumSupportDetails,
                "addedbuttonSelection":
                {
                    "addedbutton": "INR:inrlblrequired=Added,addlblrequired=Added,prmlblrequired=Added,eqmlblrequired=Added,accordionsubheaderdivinr=\n                                                                             \n                                                                        Internet Speed\n                                                                    ,accordionsubheaderdivprm=     Tech Support Pro,accordionsubheaderdivequ=     I do not need a router, I will provide my own ,accordionsubheaderdivadd=     I do not need a Security Bundle"
                }
            };
        }
    }

    if (requestFrom && requestFrom !== '') {
        requestBody.DataSelection = updateDataBodyFromPhone.DataSelection;
        requestBody.DataPlanSelection = updateDataBodyFromPhone.DataPlanSelection;
    }
    return requestBody;
}

export const formGenericStandardPhoneRequestBody = (requestParams) => {
    const {
        maintanencePlan,
        PhoneInfoResp,
        phnDirListing,
        phoneLines,
        dirList,
        premiumSupportDetails,
        batterySelected
    } = requestParams;
    const requestBody = {
        "PhoneLines": phoneLines,
        "CallingFeat": {},
        "BundleSelection": {
            "OldID": "",
            "NewID": ""
        },
        "Maintenance": { "NewID": maintanencePlan?.PrdID, "OldID": maintanencePlan?.PrdID },
        "Jacks": PhoneInfoResp?.Jacks?.map(jack => { return { "PrdID": jack.PrdID, "CountInCart": jack.CountInCart?.toString() } }),
        "DirListing": {
            "NewID": dirList.PrdID
        },
        "ListingInfo": phnDirListing || {},
        "BatterySelected": batterySelected,
        "GlobalValues": [
            {
                "key": "IsBundle",
                "value": "Y"
            },
            {
                "key": "IsWinback",
                "value": "N"
            }
        ],
        "addedbuttonSelectionphon": {
            "addedbutton": "PHN:phnplanlblrequired=Added,backuplblrequired=Added,dirlistlblrequired=Added,accordionsubheaderdivphnplan=\n\n                                                                                     Pick your Phone services\n                                                                            ,accordionsubheaderdivpowerbackup=     Voice Backup PowerReserve Declined,accordionsubheaderdivdirlist=     Non Published"
        }
    };
    if (premiumSupportDetails) {
        requestBody.SelectedPPS = premiumSupportDetails;
    }
    return requestBody;
}

export const formGenericVideoRequestBodyBasedOnFlow = (tvOrder, oldReq) => {
    const equipmentList = tvOrder[4]?.selectedDetails?.value && tvOrder[4]?.selectedDetails?.value !== '000'
        ? tvOrder[3].selectedDetails.value?.concat(tvOrder[4].selectedDetails.value)
        : tvOrder[3].selectedDetails.value;

    let requestBody = {
        "CustomCHSelection": [],
        "InternationalSelection": tvOrder[2].selectedDetails.internationalSelection,
        "MovieSelection": tvOrder[2].selectedDetails.movieSelection,
        "PeopleCount": "",
        "PlanSelection": {
            "NewID": tvOrder[1].selectedDetails.value,
            "OldID": oldReq?.PlanSelection?.NewID ? oldReq.PlanSelection.NewID : '25511754',
        },
        "QNDone": true,
        "RecordShow": false,
        "RouterSelection": {
            "NewID": tvOrder[5].selectedDetails ? tvOrder[5].selectedDetails.PrdID : "",
            "OldID": oldReq?.RouterSelection?.NewID ? oldReq.RouterSelection.NewID : '24541273'
        },
        "SatelliteOrDish": "NA",
        "SelectedEquipments": equipmentList,
        "SelectedPPS": tvOrder.premiumSupportDetails,
        "SpecialitySelection": tvOrder[2].selectedDetails.specialtySelection,
        "SportsSelection": tvOrder[2].selectedDetails.sportsSelection,
        "TOSAccepted": true,
        "TOSDone": true,
        "ViewSelection": {
            "NewID": tvOrder[0].selectedDetails.value
        },
        "addedbuttonSelectionTV": {
            "addedbutton": "TV:lblrequiredtvoption=Added,lblrequiredtvplan=Added,lblrequiredselecttvequ=Added,lblrequiredgateway=Added,lblrequiredtvprmsupport=Added,accordionsubheaderdivtvoption=     \n                                                                                Private View\n                                                                                \n                                                                            ,accordionsubheaderdivtvplan=     Fios Local TV - Private,accordionsubheaderdivtvequ=      Fios TV Equipment,accordionsubheaderdivgateway=     Purchase Fios Quantum Gateway Router,accordionsubheaderdivtvpremsupport=     I do not need a maintenance plan",
            "continuebuttonvaidation": "true"
        }
    };

    return requestBody;
}




export const formStandaloneHSIRequestBody = (requestParams) => {
    const { params } = requestParams;
    const requestBody = {
        "DataSelection": {
            //   "OldID": params[0].selectedDetails.Services[0].ID ? params[0].selectedDetails.Services[0].ID.toString() : "",
            "NewID": params[0].selectedDetails.Services[0].ID ? params[0].selectedDetails.Services[0].ID.toString() : ""
        },
        "DataPlanSelection": {
            //  "OldID": params[1].selectedDetails ? params[1].selectedDetails.PrdID : "",
            "NewID": params[1].selectedDetails ? params[1].selectedDetails.PrdID : ""
        },
        "RouterSelection": {
            "OldID": params[2].selectedDetails ? params[2].selectedDetails.PrdID : "",
            "NewID": params[2].selectedDetails ? params[2].selectedDetails.PrdID : ""
        },
        "SelectedVASPlans": (params[4].selectedDetails?.length != 0) ? params[4].selectedDetails : [
            {
                "PkgID": "",
                "PPPID": "0"
            }
        ],

        /* SelectedPPS is the Tech Support Pro and service protection plan*/
        "SelectedPPS": params.premiumSupportDetails,
        "addedbuttonSelectionhsiinr": {
            "addedbutton": "HSIINR:lblrequiredhsiinr=Added,lblrequiredhsiprem=Added,lblrequiredhsiequ=Added,lblrequiredhsiinstall=Added,lblrequiredhsiadd=Optional,accordionsubheaderdivhsiinr=     Basic Internet 2 Year,accordionsubheaderdivhsiprem=                      I do not need a maintenance plan             ,accordionsubheaderdivhsiequ=                      No thanks I’ll provide my own              ,accordionsubheaderdivhsiinstall=                      Self Installation              accordionsubheaderdivhsiadd=n                                                                             n                                                                        Add-onsn                                                                    "
        },
    };

    return requestBody;
}

/**  Double Request Payloads */
export const formDoubleDataBdvRequestBody = (DataInfoResp,
    currentBdvRequestParams, standaloneDataReqParams,
    selectedGetNonDoFlowBundleInfo, currentDataRequestParams, selectedPlanDetails) => {
    // keep standalone as old ID, curent request as NewID 
    const requiredObjects = {
        DataInfoResp,
        currentBdvRequestParams,
        currentDataRequestParams,
        standaloneDataReqParams,
        selectedGetNonDoFlowBundleInfo,
        phoneServiceType: 'BDV'
    }
    let doubleDataWithBDV = {};
    if (selectedPlanDetails && selectedPlanDetails.hasOwnProperty('BID')) {
        doubleDataWithBDV = {
            'bdvModelPost': frameDoubleBDVRequestPayload(currentBdvRequestParams, selectedPlanDetails),
            'fiOSDataModelPost': frameDoubleDATARequestPayload(requiredObjects, selectedPlanDetails),
            'FiOSTVModelPost': formTripleBdvTvRequest(selectedPlanDetails),
        };
    } else {
        doubleDataWithBDV = {
            'bdvModelPost': frameDoubleBDVRequestPayload(currentBdvRequestParams),
            'fiOSDataModelPost': frameDoubleDATARequestPayload(requiredObjects)
        };
    }
    console.log('doubleDataWithBDV', doubleDataWithBDV)

    return doubleDataWithBDV;
}

export const formDoublePhoneDATARequestBody = (currentPhoneRequestParams, standaloneDataReqParams, selectedDoubleBundleNonDoPlan, currentDataRequestParams, selectedPlanDetails) => {

    const requiredParams = {
        currentPhoneRequestParams,
        currentDataRequestParams,
        standaloneDataReqParams,
        selectedDoubleBundleNonDoPlan,
        phoneServiceType: 'Phone'
    }
    let doubleDataWithPhone = {};
    if (selectedPlanDetails) {
        doubleDataWithPhone = {
            "fiOSDataModelPost": frameDoubleDATARequestPayload(requiredParams, selectedPlanDetails),
            "voiceModelPost": frameDoublePhoneRequestPayload(currentPhoneRequestParams, selectedPlanDetails),
            'FiOSTVModelPost': formTripleBdvTvRequest(selectedPlanDetails)
        };
    } else {
        doubleDataWithPhone = {
            "fiOSDataModelPost": frameDoubleDATARequestPayload(requiredParams),
            "voiceModelPost": frameDoublePhoneRequestPayload(currentPhoneRequestParams)
        };
    }
    return doubleDataWithPhone;
}

export const formDoubleFlexDataVideoRequestBody = (currentTVRequestParams, standaloneDataReqParams, selectedGetNonDoFlowBundleInfo,
    currentDataRequestParams, tvOrder, isReverseFlow, selectedPlan, phoneServiceType) => {
    let doubleDataWithBDV = {};
    const requiredObjects = {
        currentTVRequestParams,
        currentDataRequestParams,
        standaloneDataReqParams,
        selectedGetNonDoFlowBundleInfo,
        phoneServiceType: 'TV'
    }
    if (isReverseFlow) {
        // for triple...
        if (phoneServiceType === BUNDLE.BDV) {
            doubleDataWithBDV = {
                // 'bdvModelPost': frameDoubleBDVRequestPayload(currentBdvRequestParams, selectedPlanDetails),
                'FiOSTVModelPost': frameDoubleTVRequestPayload(currentTVRequestParams),
                'fiOSDataModelPost': frameDoubleDATARequestPayload(requiredObjects)
            };
        } else {
            doubleDataWithBDV = {
                // "voiceModelPost": frameDoublePhoneRequestPayload(currentPhoneRequestParams, selectedPlanDetails),
                'FiOSTVModelPost': frameDoubleTVRequestPayload(currentTVRequestParams),
                'fiOSDataModelPost': frameDoubleDATARequestPayload(requiredObjects)
            };
        }


    } else {
        doubleDataWithBDV = {
            'FiOSTVModelPost': frameDoubleTVRequestPayload(currentTVRequestParams),
            'fiOSDataModelPost': frameDoubleDATARequestPayload(requiredObjects)
        };
    }

    return doubleDataWithBDV;
}

export const formDoublePhoneHSIRequestBody = (currentPhoneRequestParams, standaloneDataReqParams, selectedDoubleBundleNonDoPlan, currentDataRequestParams) => {
    const requiredParams = {
        currentPhoneRequestParams,
        currentDataRequestParams,
        standaloneDataReqParams,
        selectedDoubleBundleNonDoPlan,
        phoneServiceType: 'Phone'
    }

    const doubleDataWithPhone = {
        /* NO LONGER REQUIRED */
        // "hsiDataModelPost": frameDoubleHSIRequestPayload(requiredParams),
        "voiceModelPost": frameDoublePhoneRequestPayload(currentPhoneRequestParams)
    };
    return doubleDataWithPhone;
}


/**        Triple  Request Payloads */
export const formTripleBdvBundleRequestBody = (currentRequestParams, standaloneReqParams) => {
    const tripleBdvBundleRequestBody = {
        "bdvModelPost": {
            "addedbuttonSelectionBDV": {
                "addedbutton": "BDV:bdvphnnumberlblrequired=Added,bdvphnequlblrequired=Added,bdvphndirlistlblrequired=Added,accordionsubheaderdivbdvdirlist=      Non published Listing,accordionsubheaderdivbdvphnequ\n                                                     \n                                                Equipment\n\n                                            ,accordionsubheaderdivbdvdirlist      Non published Listing"
            },
            "BdvBundleSelection": {
                "NewID": "",
                "OldID": ""
            },
            "BdvDirListing": {
                "NewID": "24893667"
            },
            "BdvGlobalValues": [
                {
                    "Key": "ShipmentType",
                    "value": "T"
                },
                {
                    "key": "IsBundle",
                    "value": "Y"
                },
                {
                    "key": "IsConfTN",
                    "value": "N"
                },
                {
                    "key": "IsWinback",
                    "value": "N"
                }
            ],
            "BdvJacks": [
                {
                    "CountInCart": "0",
                    "PrdID": "25237912"
                }
            ],
            "BdvListingInfo": {
                "City": "MANHATTAN",
                "CompanyName": "",
                "Degree": "",
                "Designation": "",
                "FirstName": "",
                "LastName": "",
                "MidName": "",
                "PhoneNo": "2122204334",
                "Street": "322  ITO W ST "
            },
            "BdvMaintenance": {
                "NewID": "0"
            },
            "BdvPhoneLines": [
                {
                    "LineNO": 1,
                    "NewIsWB": "",
                    "NewPlanID": "25441888",
                    "NewTN": "2122204334",
                    "OldIsWB": "",
                    "OldPlanID": "25441888",
                    "OldTN": "2122204334"
                }
            ],
            "BdvProviderInfo": {},
            "EquipMapping": [
                {
                    "AddlHandset": "",
                    "EqpID": "25441894",
                    "TNs": [
                        "2122204334"
                    ]
                }
            ],
            "FaxJacks": [],
            "FaxLines": []
        },
        "fiOSDataModelPost": {
            "addedbuttonSelection": {
                "addedbutton": "INR:inrlblrequired=Added,addlblrequired=Added,prmlblrequired=Added,eqmlblrequired=Added,accordionsubheaderdivinr=                     Fios Internet 200M/200M - 2YR                              ,accordionsubheaderdivprm=     Tech Support Pro,accordionsubheaderdivequ=     Purchase Fios Quantum Gateway Router,accordionsubheaderdivadd=     Business Internet Secure - 5 Pack"
            },
            "BundleChoiceOffers": {},
            "DataPlanSelection": {
                "NewID": "25568282",
                //  "OldID": "25568282"
            },
            "DataSelection": {
                "NewID": "510002355",
                //  "OldID": "510002355"
            },
            "ExtenderSelection": {
                "NewID": "0"
            },
            "RouterSelection": {
                "NewID": "24541273",
                "OldID": "24541273"
            },
            "SelectedPPS": [
                {
                    "PkgID": "56578263",
                    "PPPID": "7486988",
                    "PrdCat": "VAS"
                }
            ],
            "SelectedVASPlans": [
                {
                    "PkgID": "BDLB1023",
                    "PPPID": "7486968"
                }
            ]
        },
        "FiOSTVModelPost": {
            "addedbuttonSelectionTV": {
                "addedbutton": "TV:lblrequiredtvoption=Added,lblrequiredtvplan=Added,lblrequiredselecttvequ=Added,lblrequiredgateway=Required,lblrequiredtvprmsupport=Required,lblrequiredtvchennels=Added,accordionsubheaderdivtvoption=     \n                                                                                    Private View\n                                                                                    \n                                                                                ,accordionsubheaderdivtvplan=     Fios Local TV - Private,accordionsubheaderdivtvequ=      Fios TV Equipment,accordionsubheaderdivgateway=      Fios Quantum Gateway,accordionsubheaderdivtvpremsupport=      Maintenance and Support Services",
                "continuebuttonvaidation": "optRecordNo"
            },
            "CustomCHSelection": [],
            "InternationalSelection": [],
            "MovieSelection": [
                "25020266"
            ],
            "PeopleCount": "",
            "PlanSelection": {
                "NewID": "25511754",
                "OldID": "25511754"
            },
            "QNDone": false,
            "RecordShow": false,
            "SatelliteOrDish": "NA",
            "SelectedEquipments": [
                "21685591"
            ],
            "SelectedPPS": [
                {
                    "PkgID": "56578263",
                    "PPPID": "7486988",
                    "PrdCat": "VAS"
                }
            ],
            "SpecialitySelection": [],
            "SportsSelection": [],
            "TOSAccepted": true,
            "TOSDone": true,
            "ViewSelection": {
                "NewID": "PRIVATE"
            }
        }
    };


    return tripleBdvBundleRequestBody;
}


export const formTripleSolutionBundleFiosRequestBody = (currentPhoneRequestParams, standaloneDataReqParams, selectedDoubleBundleNonDoPlan, currentDataRequestParams, currentTVRequestParams) => {
    const requiredParams = {
        currentPhoneRequestParams,
        currentDataRequestParams,
        standaloneDataReqParams,
        selectedDoubleBundleNonDoPlan,
        currentTVRequestParams,
        phoneServiceType: 'Phone'
    }

    const tripleSbFiosRequestBody = {
        "fiOSDataModelPost": frameTripleDATARequestPayload(requiredParams),
        "voiceModelPost": frameDoublePhoneRequestPayload(currentPhoneRequestParams),
        'FiOSTVModelPost': frameDoubleTVRequestPayload(currentTVRequestParams),
    };
    return tripleSbFiosRequestBody;
}

/**  Triple bundle Request Payloads */
export const formTripleDataBdvTvRequestBody = (currentBdvRequestParams, standaloneDataReqParams, selectedGetNonDoFlowBundleInfo, currentDataRequestParams, currentTVRequestParams) => {
    // keep standalone as old ID, curent request as NewID 
    const requiredObjects = {
        currentBdvRequestParams,
        currentDataRequestParams,
        standaloneDataReqParams,
        selectedGetNonDoFlowBundleInfo,
        phoneServiceType: 'BDV',
        currentTVRequestParams
    }
    const tripleDataWithBdvTv = {
        'bdvModelPost': frameDoubleBDVRequestPayload(currentBdvRequestParams),
        'fiOSDataModelPost': frameTripleDATARequestPayload(requiredObjects),
        'FiOSTVModelPost': frameDoubleTVRequestPayload(currentTVRequestParams),
    };
    return tripleDataWithBdvTv;
}


export const formTripleBdvTvRequest = (selecetedPlanDetails) => {
    const requestBody = {
        "PlanSelection": {
            "OldID": selecetedPlanDetails?.TVHCId?.toString() ? selecetedPlanDetails?.TVHCId?.toString() : '25511754',
            "NewID": selecetedPlanDetails?.TVHCId
        },
        // "ViewSelection": { "NewID": ViewSelection.value },
        // "CustomCHSelection": [],
        // "RecordShow": false,
        // "TOSAccepted": true,
        // "SelectedEquipments": equipmentList,
        // "MovieSelection": channelList.movieSelection,
        // "SportsSelection": channelList.sportsSelection,
        // "SpecialitySelection": channelList.specialtySelection,
        // "InternationalSelection": channelList.internationalSelection,
        "TOSDone": true,
        "QNDone": false,
        "PeopleCount": "",
        "SatelliteOrDish": "NA",
        "SelectedPPS": [{ "PrdCat": "VAS", "PkgID": "56578263", "PPPID": "7486988" }],
        // "RouterSelection": {
        //     "NewID": routerList.selectedDetails && routerList.selectedDetails.PrdID ? routerList.selectedDetails.PrdID : "0",
        //     "OldID": routerList.selectedDetails && routerList.selectedDetails.PrdID ? routerList.selectedDetails.PrdID : "0"
        // },
        "addedbuttonSelectionTV": { "addedbutton": "TV:lblrequiredtvoption=Added,lblrequiredtvplan=Added,lblrequiredselecttvequ=Added,lblrequiredgateway=Required,lblrequiredtvprmsupport=Required,lblrequiredtvchennels=Added,accordionsubheaderdivtvoption=     \n                                                                                    Private View\n                                                                                    \n                                                                                ,accordionsubheaderdivtvplan=     Fios Local TV - Private,accordionsubheaderdivtvequ=      Fios TV Equipment,accordionsubheaderdivgateway=      Fios Quantum Gateway,accordionsubheaderdivtvpremsupport=      Maintenance and Support Services", "continuebuttonvaidation": "optRecordYes" }
    };
    return requestBody
}


/** Frame Double Bundle Request Payloads */

export const frameDoubleBDVRequestPayload = (requestParams, selectedPlanDetails) => {
    let requestBody = {};
    const {
        maintanencePlan,
        BDVInfoResponse,
        phnDirListing,
        phoneLines,
        selectedIds,
        faxLines,
        dirList
    } = requestParams;

    requestBody = {
        "BdvPhoneLines": phoneLines,
        "BdvBundleSelection": { "OldID": BDVInfoResponse.BdvAllPlanList && BDVInfoResponse.BdvAllPlanList[0]?.BunID, "NewID": BDVInfoResponse.BdvAllPlanList && BDVInfoResponse.BdvAllPlanList[0]?.BunID },
        "BdvMaintenance": { "NewID": maintanencePlan?.PrdID, "OldID": maintanencePlan?.PrdID },
        "BdvJacks": BDVInfoResponse.BdvJacks?.map(jack => { return { "PrdID": jack.PrdID, "CountInCart": jack.CountInCart?.toString() } }),
        "EquipMapping": selectedIds.map(id => ({ EqpID: id, AddlHandset: '', TNs: [phoneLines[0].NewTN] })),
        "FaxLines": faxLines,
        "BdvProviderInfo": {},
        "FaxJacks": [],
        "BdvDirListing": { "NewID": dirList.PrdID, "OldID": BDVInfoResponse.BdvListings && BDVInfoResponse.BdvListings[1]?.PrdID },
        "BdvListingInfo": phnDirListing || {},
        "BdvGlobalValues": [
            { "key": "IsBundle", "value": "Y" },
            { "key": "IsWinback", "value": "N" },
            { "key": "IsConfTN", "value": "N" },
            { "Key": "ShipmentType", "value": "D" }
        ],
        "addedbuttonSelectionBDV": {
            "addedbutton": "BDV:bdvphnnumberlblrequired=Added,bdvphnequlblrequired=Required,bdvphndirlistlblrequired=Added,accordionsubheaderdivbdvdirlist=      Listing,accordionsubheaderdivbdvphnequ\n                                                     \n                                                Phone Equipment\n\n                                            ,accordionsubheaderdivbdvdirlist      Listing"
        }
    };

    // getSelectedBundle change bundle id to update..
    if (selectedPlanDetails && selectedPlanDetails.hasOwnProperty('BID')) {
        const planToUpdate = { "OldID": selectedPlanDetails.BID.toString(), "NewID": selectedPlanDetails.BID.toString() };
        requestBody.BdvBundleSelection = planToUpdate;
    }


    return requestBody;
}

export const frameDoubleDATARequestPayload = (requestParams, selectedPlanDetails) => {
    const {
        DataInfoResp,
        currentPhoneRequestParams,
        currentBdvRequestParams,
        currentDataRequestParams,
        standaloneDataReqParams,
        selectedDoubleBundleNonDoPlan,
        phoneServiceType,
        currentTVRequestParams
    } = requestParams;
    const fiOSDataModelPost = {};
    const dataSelection = {}, dataPlanSelection = {}, routerSelection = {}, extenderSelection = {},
        PremiumSuppService = {}, bundleChoiceOffer = {}, addedbuttonSelection = {};
    // oldIds
    // dataSelection.OldID = standaloneDataReqParams?.DataSelection?.NewID || '';
    // dataPlanSelection.OldID = standaloneDataReqParams?.DataPlanSelection?.OldID || '';
    routerSelection.OldID = standaloneDataReqParams?.RouterSelection?.OldID || '';
    extenderSelection.NewID = standaloneDataReqParams?.ExtenderSelection?.NewID || '';
    if (phoneServiceType === 'BDV') {

        // for GetBdvBundle Triple update...
        if (selectedPlanDetails && selectedPlanDetails.hasOwnProperty('BID')) {
            let newSelectedTripleDataBundleID = selectedPlanDetails.BID;
            // dataSelection.OldID = newSelectedTripleDataBundleID.toString();
            dataSelection.NewID = newSelectedTripleDataBundleID.toString();
            // new Ids...
            // dataPlanSelection.OldID = standaloneDataReqParams?.DataPlanSelection?.OldID || '';
            dataPlanSelection.NewID = selectedPlanDetails?.SpeedHCID.toString();;
            // dataPlanSelection.OldID = selectedPlanDetails?.SpeedHCID.toString();
            routerSelection.NewID = standaloneDataReqParams?.RouterSelection?.NewID || '';
        } else {
            let newSelectedDataID = DataInfoResp?.Plans?.find(plan => plan.IsSelected)?.PrdID;
            // dataSelection.OldID = '';
            dataSelection.NewID = currentBdvRequestParams?.BDVInfoResponse?.BdvAllPlanList && currentBdvRequestParams.BDVInfoResponse.BdvAllPlanList[0].BunID;
            // new Ids...
            //  dataPlanSelection.OldID = standaloneDataReqParams?.DataPlanSelection?.OldID || '';
            dataPlanSelection.NewID = newSelectedDataID;
            //routerSelection.NewID = standaloneDataReqParams?.RouterSelection?.OldID || '';

            routerSelection.OldID = standaloneDataReqParams?.RouterSelection?.OldID || '';
            routerSelection.NewID = standaloneDataReqParams?.RouterSelection?.NewID || '';
        }

    } else if (phoneServiceType === 'TV') {
        dataSelection.NewID = currentTVRequestParams.fiosTvResponse.Plans[0]?.BunID;
        // new Ids...
        dataPlanSelection.NewID = currentDataRequestParams[0]?.selectedDetails?.SpeedHCID ?
            currentDataRequestParams[0].selectedDetails.SpeedHCID.toString() : "";
        // GTSCD-1299 fix
        routerSelection.OldID = '24816339';
    } else {
        // for Phone Triple update...
        if (selectedPlanDetails && selectedPlanDetails.hasOwnProperty('BID')) {
            let newSelectedTripleDataBundleID = selectedPlanDetails.BID;
            // dataSelection.OldID = newSelectedTripleDataBundleID?.toString();
            dataSelection.NewID = newSelectedTripleDataBundleID?.toString();
            // new Ids...
            // dataPlanSelection.OldID = standaloneDataReqParams?.DataPlanSelection?.OldID || '';
            dataPlanSelection.NewID = selectedPlanDetails?.Services?.[0]?.ID?.toString();
            // dataPlanSelection.OldID = selectedPlanDetails?.Services?.[0]?.ID?.toString();
            routerSelection.NewID = standaloneDataReqParams?.RouterSelection?.NewID || '';
        } else {
            // new Ids...
            dataPlanSelection.NewID = currentDataRequestParams[0]?.selectedDetails?.Services[0].ID ?
                currentDataRequestParams[0].selectedDetails.Services[0].ID.toString() : "";
            //  dataSelection.OldID = selectedDoubleBundleNonDoPlan.BID;
            dataSelection.NewID = selectedDoubleBundleNonDoPlan?.BID || '';
            // needs to consider for plan change flow from initial to new....
            //  dataPlanSelection.OldID = selectedDoubleBundleNonDoPlan.Services[0].ID;
            dataPlanSelection.NewID = selectedDoubleBundleNonDoPlan?.Services[0]?.ID;

            extenderSelection.NewID = standaloneDataReqParams?.ExtenderSelection?.NewID || '';
            routerSelection.OldID = standaloneDataReqParams?.RouterSelection?.OldID || '';
            routerSelection.NewID = standaloneDataReqParams?.RouterSelection?.NewID || '';
        }
    }

    bundleChoiceOffer.NewID = '';

    fiOSDataModelPost.DataSelection = dataSelection;
    fiOSDataModelPost.DataPlanSelection = dataPlanSelection;
    fiOSDataModelPost.RouterSelection = routerSelection;
    fiOSDataModelPost.ExtenderSelection = extenderSelection;
    fiOSDataModelPost.BundleChoiceOffers = {};
    // standlone VAS plans...
    fiOSDataModelPost.SelectedVASPlans = standaloneDataReqParams?.SelectedVASPlans || [];
    addedbuttonSelection.addedbutton = "INR:inrlblrequired=Added,addlblrequired=Added,prmlblrequired=Added,eqmlblrequired=Added,accordionsubheaderdivinr=                     Fios Internet 100M/100M - 2YR                              ,accordionsubheaderdivprm=     Tech Support Pro,accordionsubheaderdivequ=     Purchase Fios Quantum Gateway Router,accordionsubheaderdivadd=     Business Internet Secure - 5 Pack"

    // standlone PPS plans...

    // fiOSDataModelPost.SelectedPPS = currentDataRequestParams.premiumSupportDetails;

    fiOSDataModelPost.SelectedPPS = [
        {
            "PkgID": "56578263",
            "PPPID": "7486988",
            "PrdCat": "VAS"
        }
    ];
    fiOSDataModelPost.addedbuttonSelection = addedbuttonSelection;

    return fiOSDataModelPost;
}

export const frameDoubleHSIRequestPayload = (requestParams) => {
    const {
        currentPhoneRequestParams,
        currentBdvRequestParams,
        currentDataRequestParams,
        standaloneDataReqParams,
        selectedDoubleBundleNonDoPlan,
        phoneServiceType,
        currentTVRequestParams
    } = requestParams;
    const fiOSDataModelPost = {};
    const dataSelection = {}, dataPlanSelection = {}, routerSelection = {}, extenderSelection = {},
        PremiumSuppService = {}, bundleChoiceOffer = {}, addedbuttonSelection = {}, installationSelection = {};
    // oldIds
    // dataSelection.OldID = standaloneDataReqParams?.DataSelection?.NewID || '';
    // dataPlanSelection.OldID = standaloneDataReqParams?.DataPlanSelection?.OldID || '';
    routerSelection.OldID = standaloneDataReqParams?.RouterSelection?.OldID || '';
    extenderSelection.NewID = standaloneDataReqParams?.ExtenderSelection?.NewID || '';


    if (phoneServiceType === 'Phone') {
        // new Ids...
        dataPlanSelection.NewID = currentDataRequestParams[0]?.selectedDetails?.Services[0]?.ID ?
            currentDataRequestParams[0].selectedDetails.Services[0].ID.toString() : "";
        // dataSelection.OldID = selectedDoubleBundleNonDoPlan.BID;
        dataSelection.NewID = selectedDoubleBundleNonDoPlan?.BID || '';
        // needs to consider for plan change flow from initial to new....
        // dataPlanSelection.OldID = selectedDoubleBundleNonDoPlan.Services[0].ID;
        dataPlanSelection.NewID = selectedDoubleBundleNonDoPlan?.Services[0]?.ID;

        extenderSelection.NewID = standaloneDataReqParams?.ExtenderSelection?.NewID || '';
        routerSelection.OldID = standaloneDataReqParams?.RouterSelection?.OldID || '';
        routerSelection.NewID = standaloneDataReqParams?.RouterSelection?.NewID || '';
        installationSelection.NewID = standaloneDataReqParams?.InstallationSelection?.NewID || '';
        installationSelection.OldID = '1'
    }

    bundleChoiceOffer.NewID = '';

    fiOSDataModelPost.DataSelection = dataSelection;
    fiOSDataModelPost.DataPlanSelection = dataPlanSelection;
    fiOSDataModelPost.RouterSelection = routerSelection;
    fiOSDataModelPost.ExtenderSelection = extenderSelection;
    fiOSDataModelPost.BundleChoiceOffers = {};

    fiOSDataModelPost.AddlDataPlanSelection = {
        "NewID": ""
    };
    fiOSDataModelPost.AddlRouterSelection = {
        "NewID": "0"
    };
    // standlone VAS plans...

    fiOSDataModelPost.SelectedVASPlans = standaloneDataReqParams?.SelectedVASPlans || [];
    addedbuttonSelection.addedbutton = "HSIINR:lblrequiredhsiinr=Added,lblrequiredhsiprem=Added,lblrequiredhsiequ=Added,lblrequiredhsiinstall=Added,lblrequiredhsiadd=Added,accordionsubheaderdivhsiinr=     Basic Internet Solutions Dynamic 7.1M/768K 2 Year,accordionsubheaderdivhsiprem=                  Business Preferred         ,accordionsubheaderdivhsiequ=                  Wireless Modem/Router          ,accordionsubheaderdivhsiinstall=                  Onsite Installation          accordionsubheaderdivhsiadd=     Verizon Cloud 500 GB"

    // standlone PPS plans...

    // fiOSDataModelPost.SelectedPPS = currentDataRequestParams.premiumSupportDetails;
    fiOSDataModelPost.InstallationSelection = installationSelection;
    fiOSDataModelPost.SelectedPPS = [
        {
            "PkgID": "56578263",
            "PPPID": "7486988",
            "PrdCat": "VAS"
        }
    ];
    fiOSDataModelPost.addedbuttonSelectionhsiinr = addedbuttonSelection;

    return fiOSDataModelPost;
}
export const frameDoublePhoneRequestPayload = (requestParams, selectedPlanDetails) => {
    const {
        maintanencePlan,
        PhoneInfoResp,
        phnDirListing,
        phoneLines,
        dirList,
        batterySelected
    } = requestParams;
    const requestBody = {
        "PhoneLines": phoneLines,
        "CallingFeat": {},
        "BundleSelection": {
            "OldID": PhoneInfoResp.Plans[0]?.BunID,
            "NewID": PhoneInfoResp.Plans[0]?.BunID
        },
        "Maintenance": { "NewID": maintanencePlan?.PrdID, "OldID": maintanencePlan?.PrdID },
        "Jacks": PhoneInfoResp?.Jacks?.map(jack => { return { "PrdID": jack.PrdID, "CountInCart": jack.CountInCart?.toString() } }),
        "DirListing": {
            "NewID": dirList.PrdID
        },
        "ListingInfo": phnDirListing || {},
        "BatterySelected": batterySelected,
        "GlobalValues": [
            {
                "key": "IsBundle",
                "value": "Y"
            },
            {
                "key": "IsWinback",
                "value": "N"
            }
        ],
        "addedbuttonSelectionphon": {
            "addedbutton": "PHN:phnplanlblrequired=Added,backuplblrequired=Added,dirlistlblrequired=Added,accordionsubheaderdivphnplan=\n\n                                                                                     Pick your Phone services\n                                                                            ,accordionsubheaderdivpowerbackup=     Voice Backup PowerReserve Declined,accordionsubheaderdivdirlist=     Non Published"
        }
    };
    // getSelectedBundle change bundle id to update..
    if (selectedPlanDetails && selectedPlanDetails.hasOwnProperty('BID')) {
        const planToUpdate = { "OldID": selectedPlanDetails.BID.toString(), "NewID": selectedPlanDetails.BID.toString() };
        requestBody.BundleSelection = planToUpdate;
    }

    return requestBody;
}

export const frameDoubleTVRequestPayload = (requestParams) => {

    const {
        fiosTvResponse,
        equipmentList,
        recordingList,
        channelList,
        routerList,
        ViewSelection,
        PlanSelection,
        tvOrder,
        oldTvReq,
    } = requestParams;
    const requestBody = {
        "PlanSelection": {
            "OldID": oldTvReq?.PlanSelection?.NewID ? oldTvReq.PlanSelection.NewID : '25511754',
            "NewID": PlanSelection.value
        },
        "ViewSelection": { "NewID": ViewSelection.value },
        "CustomCHSelection": [],
        "RecordShow": false,
        "TOSAccepted": true,
        "SelectedEquipments": equipmentList,
        "MovieSelection": channelList.movieSelection,
        "SportsSelection": channelList.sportsSelection,
        "SpecialitySelection": channelList.specialtySelection,
        "InternationalSelection": channelList.internationalSelection,
        "TOSDone": true,
        "QNDone": false,
        "PeopleCount": "",
        "SatelliteOrDish": "NA",
        "SelectedPPS": [{ "PrdCat": "VAS", "PkgID": "56578263", "PPPID": "7486988" }],
        "RouterSelection": {
            "NewID": routerList.selectedDetails && routerList.selectedDetails.PrdID ? routerList.selectedDetails.PrdID : "0",
            "OldID": routerList.selectedDetails && routerList.selectedDetails.PrdID ? routerList.selectedDetails.PrdID : "0"
        },
        "addedbuttonSelectionTV": { "addedbutton": "TV:lblrequiredtvoption=Added,lblrequiredtvplan=Added,lblrequiredselecttvequ=Added,lblrequiredgateway=Required,lblrequiredtvprmsupport=Required,lblrequiredtvchennels=Added,accordionsubheaderdivtvoption=     \n                                                                                    Private View\n                                                                                    \n                                                                                ,accordionsubheaderdivtvplan=     Fios Local TV - Private,accordionsubheaderdivtvequ=      Fios TV Equipment,accordionsubheaderdivgateway=      Fios Quantum Gateway,accordionsubheaderdivtvpremsupport=      Maintenance and Support Services", "continuebuttonvaidation": "optRecordYes" }
    }
    return requestBody;
}

export const frameTripleDATARequestPayload = (requestParams) => {
    const {
        currentPhoneRequestParams,
        currentBdvRequestParams,
        currentDataRequestParams,
        standaloneDataReqParams,
        selectedDoubleBundleNonDoPlan,
        phoneServiceType,
        currentTVRequestParams
    } = requestParams;
    const fiOSDataModelPost = {};
    const dataSelection = {}, dataPlanSelection = {}, routerSelection = {}, extenderSelection = {},
        PremiumSuppService = {}, bundleChoiceOffer = {}, addedbuttonSelection = {};
    // oldIds
    // dataSelection.OldID = standaloneDataReqParams?.DataSelection?.NewID || '';
    // dataPlanSelection.OldID = standaloneDataReqParams?.DataPlanSelection?.OldID || '';
    routerSelection.OldID = standaloneDataReqParams?.RouterSelection?.OldID || '';
    extenderSelection.NewID = standaloneDataReqParams?.ExtenderSelection?.NewID || '';


    if (phoneServiceType === 'BDV') {
        // dataSelection.OldID = currentBdvRequestParams?.BDVInfoResponse?.BdvAllPlanList && currentBdvRequestParams.BDVInfoResponse.BdvAllPlanList[0].BunID;
        dataSelection.NewID = currentBdvRequestParams?.BDVInfoResponse?.BdvAllPlanList && currentBdvRequestParams.BDVInfoResponse.BdvAllPlanList[0].BunID;
        // new Ids...
        dataPlanSelection.NewID = currentDataRequestParams[0]?.selectedDetails?.SpeedHCID ?
            currentDataRequestParams[0].selectedDetails.SpeedHCID.toString() : "";
    } else if (phoneServiceType === 'TV') {
        dataSelection.NewID = currentTVRequestParams?.fiosTvResponse?.Plans[0]?.BunID;
        // new Ids...
        dataPlanSelection.NewID = currentDataRequestParams[0]?.selectedDetails?.SpeedHCID ?
            currentDataRequestParams[0].selectedDetails.SpeedHCID.toString() : "";
    } else {
        // new Ids...
        dataPlanSelection.NewID = currentDataRequestParams[0]?.selectedDetails?.Services[0].ID ?
            currentDataRequestParams[0].selectedDetails.Services[0].ID.toString() : "";
        // dataSelection.OldID = selectedDoubleBundleNonDoPlan.BID;
        dataSelection.NewID = selectedDoubleBundleNonDoPlan?.BID || '';
        // needs to consider for plan change flow from initial to new....
        // dataPlanSelection.OldID = selectedDoubleBundleNonDoPlan.Services[0].ID;
        dataPlanSelection.NewID = selectedDoubleBundleNonDoPlan?.Services[0]?.ID;

        extenderSelection.NewID = standaloneDataReqParams?.ExtenderSelection?.NewID || '';
        routerSelection.OldID = standaloneDataReqParams?.RouterSelection?.OldID || '';
    }

    bundleChoiceOffer.NewID = '';

    fiOSDataModelPost.DataSelection = dataSelection;
    fiOSDataModelPost.DataPlanSelection = dataPlanSelection;
    fiOSDataModelPost.RouterSelection = routerSelection;
    fiOSDataModelPost.ExtenderSelection = extenderSelection;
    fiOSDataModelPost.BundleChoiceOffers = {};
    // standlone VAS plans...
    fiOSDataModelPost.SelectedVASPlans = standaloneDataReqParams?.SelectedVASPlans || [];
    addedbuttonSelection.addedbutton = "INR:inrlblrequired=Added,addlblrequired=Added,prmlblrequired=Added,eqmlblrequired=Added,accordionsubheaderdivinr=                     Fios Internet 100M/100M - 2YR                              ,accordionsubheaderdivprm=     Tech Support Pro,accordionsubheaderdivequ=     Purchase Fios Quantum Gateway Router,accordionsubheaderdivadd=     Business Internet Secure - 5 Pack"

    // standlone PPS plans...

    // fiOSDataModelPost.SelectedPPS = currentDataRequestParams.premiumSupportDetails;

    fiOSDataModelPost.SelectedPPS = [
        {
            "PkgID": "56578263",
            "PPPID": "7486988",
            "PrdCat": "VAS"
        }
    ];
    fiOSDataModelPost.addedbuttonSelection = addedbuttonSelection;

    return fiOSDataModelPost;
}

/**        Get  Request Payloads from State */
export const getRequestPayloadBasedOnBundleType = (params) => {
    const { allFlowRequestPayLoads, bundleType } = params;
    let neededRequestPayload = {};
    const neededRequestPayloadIdx = allFlowRequestPayLoads.findIndex((plan) => plan.id === bundleType);
    if (neededRequestPayloadIdx > -1) {
        neededRequestPayload = allFlowRequestPayLoads[neededRequestPayloadIdx].selectedPlans;
    }
    return neededRequestPayload;
}

/**        Get  Request Payloads from State */
export const getSelectedBundleInfoBasedOnBundleType = (params) => {
    const { selectedGetNonDoFlowBundlePlan, bundleType } = params;
    let neededBundleInfo = {};
    const neededBundleInfoIdx = selectedGetNonDoFlowBundlePlan.findIndex((plan) => plan.id === bundleType);
    if (neededBundleInfoIdx > -1) {
        neededBundleInfo = selectedGetNonDoFlowBundlePlan[neededBundleInfoIdx].selectedPlans;
    }
    return neededBundleInfo;
}

/**        Get  Selected Non Do Bundle Plans from State */
export const getNonDoBundlePlanBasedOnBundleType = (params) => {
    const { allSelectedNonDoBundlePlans, bundleType } = params;
    let neededNonDoPlan = {};
    const neededNonDoPlanIdx = allSelectedNonDoBundlePlans.findIndex((plan) => plan.id === bundleType);
    if (neededNonDoPlanIdx > -1) {
        neededNonDoPlan = allSelectedNonDoBundlePlans[neededNonDoPlanIdx].selectedPlans;
    }
    return neededNonDoPlan;
}

export const formatTvPlanForBundle = (plan, viewType, isCustom = false) => {
    if ((!isCustom && plan.TVView === viewType) || (isCustom && plan.TvView === viewType)) {
        plan.planType = 'LOCAL';
        const keywords = plan.Keyword.split('|').filter(kw => kw?.length > 0);
        for (const kw of keywords) {
            const k = kw.split(':');
            switch (k[0]) {
                case 'Tier':
                    plan.focTier = k[1];
                    break;
                case 'RSN':
                    plan.RSN = true;
                    break;
                case 'CURRENT':
                    plan.planType = 'CURRENT';
                    break;
                case 'PREFERRED':
                    plan.planType = 'PREFERRED';
                    break;
                case 'EXTREME':
                    plan.planType = 'EXTREME';
                    break;
                case 'ULTIMATE':
                    plan.planType = 'ULTIMATE'
                    break;
                case 'FLEXCHOICE':
                    plan.planType = 'CUSTOM';
                    break;
                case 'NEWSVARIETY':
                    plan.customPlan = 'NEWSVARIETY';
                    break;
                case 'SPORTSNEWS':
                    plan.customPlan = 'SPORTSNEWS';
                    break;
                case 'INFODRAMA':
                    plan.customPlan = 'INFODRAMA'
                    break;
                case 'ACTIONENT':
                    plan.customPlan = 'ACTIONENT';
                    break;
                case 'LIFESTYLE':
                    plan.customPlan = 'LIFESTYLE';
                    break;
                case 'KIDSPOP':
                    plan.customPlan = 'KIDSPOP';
                    break;
                case 'FAMILY':
                    plan.customPlan = 'FAMILY';
                    break;
                default:
                    break;
            }
        }
    }
    return plan;
}



export const getBDVEquipments = (BDVInfoResponse,enableBDVW) => {
    if (BDVInfoResponse && BDVInfoResponse?.BDVEquip?.length) {
        let equipmentList = {
            "desktopList": [],
            "cordsList": [],
            "accessoriesList": []
        };
        const { BDVEquip: BdvEquipments } = BDVInfoResponse;
        let phoneList = JSON.parse(JSON.stringify(equipments));
        for (let i = 0; i < BdvEquipments?.length; i++) {
            let eachBdv = BdvEquipments[i];
            let mockObj = phoneList.filter(e => e.PrdID === eachBdv.ProductId);
            eachBdv.PrdID = eachBdv.ProductId;
            eachBdv.eachMonthPrice = ((eachBdv.Price) / 12).toFixed(2);
            eachBdv.Quantity = (eachBdv.Quantity==1 && enableBDVW === 'Y') ? 0 :parseInt(eachBdv.Quantity);
            eachBdv.updateCart = (eachBdv.IsSelected && eachBdv.Quantity) ? true : false;
            eachBdv.FeatureList = mockObj[0]?.FeatureList || phoneList[0]?.FeatureList || [];
            eachBdv.ImgUrl = mockObj[0]?.ImgUrl || phoneList[0]?.ImgUrl || '';

            if (eachBdv.ProductSubChoice === "BDVIPPHONE") {
                equipmentList.desktopList.push(eachBdv);
            } else if (eachBdv.ProductSubChoice === "BDVDESKPHONE") {
               // equipmentList.cordsList.push(eachBdv);
            } else if (eachBdv.ProductSubChoice === "BDVGATEWAY") {
               // equipmentList.accessoriesList.push(eachBdv);
            }
        }
        // equipmentList.cordsList = equipmentList.cordsList.reverse();
        equipmentList.phoneList = BdvEquipments;

        // Added for new equipment bdv changes
        equipmentList.desktopList = BdvEquipments;
        
        return equipmentList;
    }
    return {};
}